import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { auth, db } from "../config";

function WithdrawalHistory() {
  const [withdrawals, setWithdrawals] = useState([]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const q = query(
            collection(db, "withdrawals"),
            where("userId", "==", user.uid)
          );
          const querySnapshot = await getDocs(q);
          const data = querySnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setWithdrawals(data);
        } catch (error) {
          console.error("Error fetching withdrawals:", error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      <Helmet>
        <script src="https://forthfunded.com/assets/libs/@popperjs/core/umd/popper.min.js" />
        <script src="https://forthfunded.com/assets/libs/bootstrap/js/bootstrap.bundle.min.js" />
        <script src="https://forthfunded.com/assets/js/defaultmenu.min.js" />
        <script src="https://forthfunded.com/assets/libs/node-waves/waves.min.js" />
        <script src="https://forthfunded.com/assets/js/sticky.js" />
        <script src="https://forthfunded.com/assets/libs/simplebar/simplebar.min.js" />
        <script src="https://forthfunded.com/assets/js/simplebar.js" />
        <script src="https://forthfunded.com/assets/libs/@simonwep/pickr/pickr.es5.min.js" />
        <script src="https://forthfunded.com/assets/libs/apexcharts/apexcharts.min.js" />
        <script src="https://forthfunded.com/assets/js/crypto-dashboard.js" />
        <script src="https://forthfunded.com/assets/js/custom-switcher.min.js" />
        <script src="https://forthfunded.com/assets/js/custom.js" />
      </Helmet>
      <div className="page">
        <Header />
        <Nav />
        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title fw-semibold fs-18 mb-0">
                Withdrawal History
              </h1>
              <div className="ms-md-1 ms-0">
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Withdrawal
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap w-100">
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Pay Type</th>
                            <th>Status</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {withdrawals.length > 0 ? (
                            withdrawals.map((withdrawal) => (
                              <tr key={withdrawal.id}>
                                <td>${withdrawal.amount.toFixed(2)}</td>
                                <td>{withdrawal.walletAddress}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      withdrawal.status === "pending"
                                        ? "bg-warning"
                                        : withdrawal.status === "completed"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {withdrawal.status}
                                  </span>
                                </td>
                                <td>
                                 {withdrawal.createdAt?.toDate
                      ? withdrawal.createdAt.toDate().toLocaleString()
                      : new Date(withdrawal.createdAt).toLocaleString()}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No withdrawals found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="footer mt-auto py-3 bg-white text-center">
          <div className="container">
            <span className="text-muted"> Copyright © 2025</span>
            <a href="javascript:void(0);" className="text-dark fw-semibold">
              FarYieldFi
            </a>
            . All Rights Reserved
            <center>
              <div className="icon-before">
                <div className="icon-bar">
                  <center>
                    <img src="../flag.png" alt="Language flag" width={160} />
                  </center>
                  <div id="google_translate_element" />
                </div>
              </div>
            </center>
          </div>
        </footer>

        <div className="scrollToTop">
          <span className="arrow">
            <i className="ri-arrow-up-s-fill fs-20" />
          </span>
        </div>
        <div id="responsive-overlay" />
      </div>
    </div>
  );
}

export default WithdrawalHistory;
